/**
 * @generated SignedSource<<19f40a280a0887e49854d03715c920a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedFollowSearchBanner_viewer$data = {
  readonly followSearchRedesign: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"SaveSearchButton_viewer">;
  readonly " $fragmentType": "SharedFollowSearchBanner_viewer";
};
export type SharedFollowSearchBanner_viewer$key = {
  readonly " $data"?: SharedFollowSearchBanner_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedFollowSearchBanner_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedFollowSearchBanner_viewer",
  "selections": [
    {
      "alias": "followSearchRedesign",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "followSearchRedesign"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"followSearchRedesign\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SaveSearchButton_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "21c735f0636b90c46c36558ac51864dc";

export default node;
